import { gql } from '@apollo/client';

export const GET_ACTIVE_ITEMS = gql`
query getAllItem {
    allItem {
        edges{
          node{
            id
            price
            name
            url
            weight
            length
            width
            height
            pickupMsk
            pickupSpb
            soonActive
            photo
            photoResized
            tags {
              edges {
                node {
                  title
                }
              }
            } 
            createdAt
            points
            files{
              edges{
                node{
                  file
                  fileResized
                }
              }
            }
            descriptionShort
            descriptionFull
            amount
            isActive
          }
        }
    }
}`;

export const GET_ACTIVE_DIGITALS = gql`
query getAllDigitals {
    allDigital {
        edges{
          node{
            id
            price
            name
            link
            url
            soonActive
            photo
            photoResized
            tags {
              edges {
                node {
                  title
                }
              }
            } 
            createdAt
            points
            files{
              edges{
                node{
                  file
                }
              }
            }
            descriptionShort
            descriptionFull
            isActive
          }
        }
    }
}`

export const GET_ONE_DIGITAL = gql`
query getAllDigitals($url: String!) {
    allDigital(url: $url) {
        edges{
          node{
            id
            price
            name
            link
            url
            soonActive
            photo
            photoResized
            tags {
              edges {
                node {
                  title
                }
              }
            } 
            createdAt
            points
            files{
              edges{
                node{
                  file
                }
              }
            }
            descriptionShort
            descriptionFull
            isActive
          }
        }
    }
}`;

export const GET_DIGITAL_STATUS = gql`
query getAllDigitals($url: String!) {
    allDigital(url: $url) {
        edges{
          node{
            id
            price
            soonActive
            isActive
          }
        }
    }
}`;


export const GET_ONE_ITEM = gql`
query getAllItems($url: String!){ 
    allItem(url: $url) {
        edges{
          node{
            id
            price
            name
            photo
            photoResized
            createdAt
            points
            url
            soonActive
            tags {
              edges {
                node {
                  title
                }
              }
            } 
            files{
              edges{
                node{
                  file
                  fileResized
                }
              }
            }
            descriptionShort
            descriptionFull
            amount
            isActive
          }
        }
    }
}`;

export const GET_ITEM_STATUS = gql`
query getAllItems($url: String!){ 
    allItem(url: $url) {
        edges{
          node{
            id
            price
            amount
            soonActive
            isActive
          }
        }
    }
}`;

export const GET_CART_ITEMS = gql`
query getAllItem {
    allItem {
        edges{
          node{
            id
            price
            name
            url
            weight
            length
            width
            height
            pickupMsk
            pickupSpb
            soonActive
            isActive
            photo
            photoResized
            tags {
              edges {
                node {
                  title
                }
              }
            } 
            createdAt
            points
            files{
              edges{
                node{
                  file
                  fileResized
                }
              }
            }
            descriptionShort
            descriptionFull
            amount
            isActive
          }
        }
    }
}`;

export const CREATE_BUY = gql`
mutation CreateBuy(
    $items: JSONString!,
    $customerPhone: String!,
    $customerName: String!,
    $customerSurname: String!,
    $customerEmail: String!,
    $customerSex: String = "F",
    $customerBirthday: String = "1900-01-01",
    $customerSkype: String = "",
    $comment: String,
    $index: String, 
    $address: String, 
    $city: String, 
    $region: String, 
    $country: String,
    $delivery: String!,
    $oldAddress: String,
    $tarif: Int,
    $price: String,
    $pvz: String,
    $paymentSystem: String = "A",
    $utmSource: String,
    $utmMedium: String,
    $utmContent: String,
    $saleSum: Int = 0
) {
    createBuy(
        items: $items,
        comment: $comment,
        saleSum: $saleSum,
        delivery: {
            dType: $delivery,
            cdek: {
                tarif: $tarif,
                price: $price,
                pvz: $pvz
            }
            oldAddress: $oldAddress,
            newAddress: {
                index: $index,
                address: $address,
                city: $city,
                region: $region,
                country: $country
            }
        },
        paymentSystem: $paymentSystem,
        customerData: {
            customerName: $customerName,
            customerSurname: $customerSurname,
            customerPhone: $customerPhone,
            customerEmail: $customerEmail,
            customerSex: $customerSex,
            customerBirthday: $customerBirthday,
            customerSkype: $customerSkype
        },
        utm: {
            source: $utmSource,
            medium: $utmMedium,
            content: $utmContent
        }
    ){
        error
        buy{
            payment{
                status
                alfa{
                    payUrl
                }
                yandex{
                    payUrl
                }
            }
        }
    }
}`;

export const CREATE_DIGITAL = gql`
mutation CreatePurchase(
    $digital: ID!,
    $customerPhone: String!,
    $customerName: String!,
    $customerSurname: String!,
    $customerEmail: String!,
    $customerSex: String = "F",
    $customerBirthday: String = "1900-01-01",
    $customerSkype: String = "",
    $comment: String,
    $paymentSystem: String = "A",
    $utmSource: String,
    $utmMedium: String,
    $utmContent: String,
    $saleSum: Int = 0
) {
    createPurchase(
        digital: $digital,
        comment: $comment,
        paymentSystem: $paymentSystem,
        saleSum: $saleSum,
        customerData: {
            customerName: $customerName,
            customerSurname: $customerSurname,
            customerPhone: $customerPhone,
            customerEmail: $customerEmail,
            customerSex: $customerSex,
            customerBirthday: $customerBirthday,
            customerSkype: $customerSkype
        },
        utm: {
            source: $utmSource,
            medium: $utmMedium,
            content: $utmContent
        }
    ){
        error
        purchase{
            payment{
                status
                alfa{
                    payUrl
                }
                yandex{
                    payUrl
                }
            }
        }
    }
}`;

